import { render } from "./PaymentsTable.vue?vue&type=template&id=6a1036dd&scoped=true"
import script from "./PaymentsTable.vue?vue&type=script&lang=js"
export * from "./PaymentsTable.vue?vue&type=script&lang=js"

import "./PaymentsTable.vue?vue&type=style&index=0&id=6a1036dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1036dd"]])

export default __exports__